module.exports = __webpack_public_path__ + "img/booking-large.918ab1c7.svg";